"use client"
import React, { useEffect, useState } from 'react'
import useSleep from './useSleep'
import styles from './sleep.module.scss'
import Icon from '@components/icon'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Button from '@components/buttons/button'
dayjs.extend(duration)

const OPTIONS = [
    {
        label: '1 דקות',
        value: 1
    },
    {
        label: '15 דקות',
        value: 15
    },
    {
        label: '30 דקות',
        value: 30
    }, {
        label: 'שעה',
        value: 60
    }, {
        label: '3 שעות',
        value: 180
    }, {
        label: '8 שעות',
        value: 480
    }, {
        label: '12 שעות',
        value: 720
    }
]

export default function Sleep({stationId}: {stationId: string}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const { set, cancel, timer, selected } = useSleep(stationId)

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen)
    }

    const handleTimerSelect = (minutes: number) => {
        set(minutes)
        setIsDropdownOpen(false)
    }

    const formatTimeLeft = (seconds: number) => {
        const durationObj = dayjs.duration(seconds, 'seconds')
        const hours = durationObj.hours()
        const minutes = durationObj.minutes()
        const secs = durationObj.seconds().toString().padStart(2, '0')
    
        if (hours > 0) {
            return `${hours}:${minutes.toString().padStart(2, '0')}:${secs}`
        } else if (minutes > 0) {
            return `${minutes}:${secs}`
        } else {
            return `0:${secs}`
        }
    }

    const handleClickOutside = (e: MouseEvent) => {
        if (!document.querySelector(`.${styles.dropdown}`)?.contains(e.target as Node)) {
            setIsDropdownOpen(false)
        }
    }

    useEffect(() => {
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [isDropdownOpen])

    return (
        <Button className={`${styles.container} click ${timer > 0 && styles.active}`} onClick={toggleDropdown}>
            <div className={`${styles.icons}`}>
                <Icon icon={['far', 'clock']} className='animated' />
                <span>
                {
                    timer > 0 ? 
                        formatTimeLeft(timer)
                        : 'טיימר שינה'
                }
                </span>
            </div>
            {isDropdownOpen && (
                <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                    <span>טיימר שינה</span>
                    <ul>
                        {OPTIONS.map((option) => (
                            <li 
                                key={option.value} 
                                className={`animated click ${selected === option.value && styles.active}`}
                                onClick={() => handleTimerSelect(option.value)}
                            >
                                {option.label}
                            </li>
                        ))}
                        {
                            timer > 0 && (
                                <li onClick={cancel} className={`animated click`}>
                                    ביטול
                                </li>
                            )
                        }
                    </ul>
                </div>
            )}
        </Button>
    )
}